import React from "react";
import Item from "./Item";

export default class ProductGrid extends React.Component {
    render() {
        var productList = [];

        if (this.props.products.length > 0) {
            productList = this.props.products.map((item, key) => {
                return <Item key={key}
                            title={item.name}
                            mediaUrl={item.image.mediaItemUrl}
                            mediaGallery={item.galleryImages.nodes}
                            variations={item.variations.nodes}
                            slug={"/shop/" + item.productCategories.edges[0].node.name.toLowerCase() + "/" + item.slug}
                            category={item.productCategories.edges[0].node.name} />;
            });
        } else {
            for (var x = 0; x < this.props.perPage; x++) {
                productList.push(<Item key={x} placeholder={true} />);
            }
        }

        return <div className="product-grid">
            {productList}
        </div>;
    }
}